import React from 'react';
import Hobbies from '../components/Hobbies';

const HobbiesPage = () => {
  return (
    <div>
      <Hobbies />
    </div>
  );
};

export default HobbiesPage;

